import React from 'react'
import Logo from '../../../images/logos/iprshealth.svg';
import '../../referralForm/styles.css';

const ReferralFormHeader = () => {
  return (
    <header className="container referralFormHeader">
        <header className="topHeader main__top">
            <div className="main__top-logo">
            <img src={Logo} alt="IPRS Health" />
            </div>
        </header>
        
        <div className="header__supplementary">
        </div>
    </header>
  )
}

export default ReferralFormHeader